import SEO from "../common/SEO";
import Separator from "../elements/separator/Separator";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import HeaderOne from "../common/header/HeaderOne";
import CounterUpFour from "../elements/counterup/CounterUpFour";
import ServiceOne from "../elements/service/ServiceOne";
import FooterThree from "../common/footer/FooterThree";
import CalltoActionEight from "../elements/calltoaction/CalltoActionEight";
import TimelineOne from "../elements/timeline/TimelineOne";
import { Link } from "react-router-dom";

const MoftahSolutions = () => {
  return (
    <>
      <SEO title="Software Agency" />
      <main className="page-wrapper ">
        <HeaderOne btnStyle="btn-small" HeaderStyle="header-not-transparent" />

        {/* Start Slider Area  */}
        <div className="slider-area slider-style-8 height-60vh mx-4">
          <div className="single-slide">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-lg-12">
                  <div className="inner text-center">
                    <span className="subtitle theme-gradient">
                      Unlocking Potential
                    </span>
                    <h1 className="title">Moftah Solutions</h1>
                    <p className="description">
                      A Premier Software Consulting Partner
                    </p>
                    <div className="button-group mt--30">
                      <Link to="/contact" className="btn-default btn-large round">
                        Contact Us
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Slider Area  */}

        {/* Start Counterup Area  */}
        <div className="our-counterup-area mx-4">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                {/* <div className="thumbnail">
                  <img
                    className="radius w-100"
                    src="./images/bg/bg-image-21.png"
                    alt="Images"
                  />
                </div> */}
                {/* Start Elements Area  */}
                <div className="rwt-counterup-area">
                  <div className="col-lg-12">
                    <CounterUpFour
                      column="col-lg-4 col-md-4 col-sm-4 col-12"
                      counterStyle="counter-style-4"
                      textAlign="text-center"
                    />
                  </div>
                </div>
                {/* End Elements Area  */}
              </div>
            </div>
          </div>
        </div>
        {/* End Counterup Area  */}

        <Separator />

        {/* Start Service Area  */}
        <div className="service-area rn-section-gapTop mx-4">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <div className="content">
                  <h3 className="title">
                    Elevate Your Business with Moftah Solutions
                  </h3>
                </div>
              </div>
              <div className="col-lg-6">
                <p className="mb--10">
                  Moftah Solutions is a premier software consulting company
                  dedicated to providing top-notch software solutions tailored
                  to meet the diverse needs of businesses, ranging from startups
                  to mid-sized companies. Specializing in full stack
                  development, we offer a comprehensive suite of services to
                  address all your software requirements.
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* End Service Area  */}

        {/* Start Service Area  */}
        <div className="rn-service-area rn-section-gap mx-4">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <SectionTitle
                  textAlign="text-center"
                  radiusRounded=""
                  subtitle="Why Choose Us"
                  title="What we offer."
                />
              </div>
            </div>
            <ServiceOne
              serviceStyle="service__style--1 bg-color-blackest radius mt--25"
              textAlign="text-center"
            />
          </div>
        </div>
        {/* End Service Area  */}

        {/* Start Timeline Area  */}
        <div className="rwt-timeline-area rn-section-gap mx-5">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <SectionTitle
                  textAlign="text-center"
                  radiusRounded=""
                  subtitle="How Does It Work"
                  title="Process"
                />
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <TimelineOne />
              </div>
            </div>
          </div>
        </div>
        {/* End Timeline Area  */}

        <CalltoActionEight />
        <FooterThree />
      </main>
    </>
  );
};
export default MoftahSolutions;
